// extracted by mini-css-extract-plugin
module.exports = {"title":"Content068_title__C7wJv","content":"Content068_content__YWdzo","wrapper":"Content068_wrapper__UiPyE"};